import { render, staticRenderFns } from "./SituacoesListagem.vue?vue&type=template&id=af39b3b0&scoped=true&"
import script from "./SituacoesListagem.vue?vue&type=script&lang=js&"
export * from "./SituacoesListagem.vue?vue&type=script&lang=js&"
import style0 from "./SituacoesListagem.vue?vue&type=style&index=0&id=af39b3b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af39b3b0",
  null
  
)

export default component.exports